if (document.querySelector('.menu-button')) {
	const btn = document.querySelector(".menu-button");
	const menu = document.querySelector(".main-navigation");
	
	btn.addEventListener("click", () => {
		menu.classList.toggle("hidden");
		btn.classList.toggle("active");
	});
	
	const arrowButton = document.querySelectorAll(".sub-toggle");
	
	arrowButton.forEach((el) =>
		el.addEventListener("click", (event) => {
			const subMenu = event.target.parentElement.querySelector(".sub-menu");
			subMenu.classList.toggle("show");
		})
	);
}
